module.exports = __webpack_public_path__ + "img/IgorFernandes.71ae4f9d.png";